module.exports = __webpack_public_path__ + "static/img/logo-meduni-vienna-cmpbe.ddc6b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-meduni-vienna-cmpbe.png
// module id = IUw0
// module chunks = 1